import React, { } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import ServiceButtonWithToast from '../../_common/ServiceButtonWithToast';

export default function GenericBooleanConditionSubForm(props) {
  const {
    conditionType,
    onSubmit,
    onSuccess,
    successMsg,
  } = props;

  const handleSave = () => onSubmit({
    conditionType,
  });

  return (
    <Grid item xs={10}>
      <ServiceButtonWithToast
        service={handleSave}
        onSuccess={onSuccess}
        successMsg={successMsg}
        buttonText="Save"
      />
    </Grid>
  );
}

GenericBooleanConditionSubForm.propTypes = {
  conditionType: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onSuccess: PropTypes.func,
  successMsg: PropTypes.string,
};

GenericBooleanConditionSubForm.defaultProps = {
  onSuccess: undefined,
  successMsg: undefined,
};
